import { ChatWidget } from './components/ChatWidget';
import { AuthProvider } from './context/AuthContext';
import { useVisualViewport } from './hooks/useVisualViewport';

export function App() {
  // Handle iOS Safari viewport (toolbar covering content)
  useVisualViewport();

  return (
    <AuthProvider>
      <div style={{ height: 'var(--vh, 100vh)', width: '100%', maxWidth: '100vw', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <header
          style={{
            padding: '1rem',
            background: '#1a1a2e',
            color: 'white',
            textAlign: 'center',
          }}
        >
          <h1 style={{ fontSize: '1.25rem', margin: 0 }}>Order Assistant</h1>
        </header>
        <main style={{ flex: 1, overflow: 'hidden' }}>
          <ChatWidget />
        </main>
      </div>
    </AuthProvider>
  );
}
